import React, { useState, useEffect } from "react";
import CustomChart from "../Charts";
import styles from "./kpiCard.module.scss";

const KPIBubbleChart = ({ data, theme }) => {
  const [chartData, setChartData] = useState(null);
  const [error, setError] = useState(null);
  const [options, setOptions] = useState({
    responsive: true,
    maintainAspectRatio: false,
    scales: {
      x: {
        display: false,
        grid: {
          display: false,
        },
      },
      y: {
        display: false,
        grid: {
          display: false,
        },
      }
    },
    plugins: {
      legend: {
        display: false // ❌ Hides the legend
      },
      tooltip: {
        callbacks: {
          label: (context) => {
            const point = context.raw;
            return [
              `Topic: ${point.label}`
            ];
          }
        }
      },
      datalabels: {
        color: 'white',
        font: {
          size: 11
        },
        formatter: (value) => {
          return value;
        },
        display: true,
        anchor: "center",
        align: "center",
      }
    },
    backgroundColor: 'transparent',
    layout: {
      padding: {
        left: 10,
        right: 10,
        top: 10,
        bottom: 10
      }
    },
    elements: {
      point: {
        backgroundColor: 'transparent'
      }
    },
    animation: {
      duration: 0
    }
  });

  useEffect(() => {
    try {
      if (!data || !data.datasets || !Array.isArray(data.datasets)) {
        setError("No data available");
        return;
      }

      // The data is already in the correct format from the API
      const processedData = data;

      // Calculate ranges for x and y axes with padding
      const dataset = data.datasets[0];
      const xValues = dataset.data.map(point => point.x);
      const yValues = dataset.data.map(point => point.y);
      const xMin = Math.min(...xValues);
      const xMax = Math.max(...xValues);
      const yMin = Math.min(...yValues);
      const yMax = Math.max(...yValues);
      
      const xPadding = (xMax - xMin) * 0.1;
      const yPadding = (yMax - yMin) * 0.1;

      setOptions(prevOptions => ({
        ...prevOptions,
        scales: {
          ...prevOptions.scales,
          x: {
            ...prevOptions.scales.x,
            min: xMin - xPadding,
            max: xMax + xPadding
          },
          y: {
            ...prevOptions.scales.y,
            min: yMin - yPadding,
            max: yMax + yPadding
          }
        }
      }));

      setChartData(processedData);
      setError(null);
    } catch (err) {
      setError("Error processing data");
      console.error("Error in KPIBubbleChart:", err);
    }
  }, [data]);

  if (error) {
    return <div className={styles.error}>{error}</div>;
  }

  if (!chartData) {
    return <div className={styles.loading}>Loading...</div>;
  }

  return (
    <div className={styles.chartContainer}>
      <CustomChart
        type="bubble"
        data={chartData}
        options={options}
        width={400}
        height={400}
        theme={theme}
      />
    </div>
  );
};

export default KPIBubbleChart;
